import { Stack, Divider, Grid2 } from '@mui/material'
import { TextField } from '@ui/forms'

const FormFields = () => {
  return (
    <Stack direction="column" spacing={2}>
      <TextField
        label="Abgabedatum DD.MM.YYYY"
        name="hand_in_date"
        rows={1}
        data-cy="hand_in_date-input"
        placeholder="TT.MM.YYYY"
      />

      <Divider />

      <Grid2 container spacing={2}>
        <Grid2 size={6}>
          <TextField name="project_description" label="Projektbeschreibung" disabled />
        </Grid2>
        <Grid2 size={6}>
          <TextField name="responsible_user_name" label="Planungsverantwortung" disabled />
        </Grid2>
        <Grid2 size={6}>
          <TextField name="address_street" label="Projektadresse - Straße" disabled />
        </Grid2>
        <Grid2 size={6}>
          <TextField name="address_city" label="Projektadresse - Stadt" disabled />
        </Grid2>
        <Grid2 size={6}>
          <TextField name="address_zip_code" label="Projektadresse - PLZ" disabled />
        </Grid2>
        <Grid2 size={6}>
          <TextField name="owner_name" label="Bauverantwortlicher" disabled />
        </Grid2>
        <Grid2 size={6}>
          <TextField name="owner_address" label="Adresse des Bauverantwortlichen" disabled />
        </Grid2>
        <Grid2 size={6}>
          <TextField name="primary_editor_name" label="Bearbeitung durch" disabled />
        </Grid2>
      </Grid2>
    </Stack>
  )
}

export default FormFields
